import { connect } from 'react-redux';
import { selectors } from '@makemydeal/dr-offer-redux';
import { getIsDueAtSigninAmountDeduct } from './selectors';
import ServicesSummaryUI from './ServicesSummaryUI';
import { routingActionCreator } from './actions/routingActionCreators';

const mapStateToProps = (state, ownProps) => {
    const offerType = selectors.getCurrentOfferType(state);
    const isLeaseOfferType = offerType === 'lease';
    const useNewLeaseVerbiage = ownProps && ownProps.useNewLeaseVerbiage;
    const offerSummary = selectors.getOfferSummary(state, offerType);
    const dealSummary = offerSummary.dealSummary;
    const isDealSummaryDisplayed = selectors.isDealSummaryDisplayed(state);

    let downPaymentText = 'Down Payment';
    let downPaymentTextSecond = 'Down Payment'; // Lease Cap Cost logic changes this label but leaves the above label as is
    let dueAtSigningText = 'Total Due At Signing';

    if (isLeaseOfferType && useNewLeaseVerbiage) {
        const isDueAtSigninAmountDeduct = getIsDueAtSigninAmountDeduct(state);
        downPaymentText = 'Cap Cost Reduction';
        dueAtSigningText = 'Due At Signing';
        downPaymentTextSecond = isDueAtSigninAmountDeduct ? 'Cap Cost Reduction' : 'Cash Down';
    }
    return {
        dealSummary,
        downPaymentText,
        downPaymentTextSecond,
        dueAtSigningText,
        advertisedPriceLabel: ownProps.advertisedPriceLabel || 'Advertised Price',
        specialsLabel: ownProps.specialsLabel === undefined ? 'Specials' : ownProps.specialsLabel,
        isDealSummaryDisplayed
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        onAdjustedCashInfoClick(route) {
            return dispatch(routingActionCreator(route));
        }
    };
};

const ServicesSummary = connect(
    mapStateToProps,
    mapDispatchToProps
)(ServicesSummaryUI);

export default ServicesSummary;
